import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const ChevronRight = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 17.644531 11.394531 C 18.21875 10.824219 19.125 10.785156 19.738281 11.289062 L 19.855469 11.394531 L 32.355469 23.894531 L 32.460938 24.011719 C 32.929688 24.585938 32.929688 25.414062 32.460938 25.988281 L 32.355469 26.105469 L 19.855469 38.605469 C 19.246094 39.214844 18.253906 39.214844 17.644531 38.605469 C 17.035156 37.996094 17.035156 37.003906 17.644531 36.394531 L 29.039062 25 L 17.644531 13.605469 L 17.539062 13.488281 C 17.035156 12.875 17.074219 11.96875 17.644531 11.394531 Z M 17.644531 11.394531 "
        fill={color}
      />
    </svg>
  )
}
